// Typelizer digest 86f79632434b761a00d5eb7829196ab3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /admin/productions/:production_id/lines/:id/generate */
  generate: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/lines/:id/generate', params, options),
    method: 'post',
  }),

  /** GET /admin/productions/:production_id/lines/:id */
  show: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/lines/:id', params, options),
    method: 'get',
  }),

  /** PATCH /admin/productions/:production_id/lines/:id */
  update: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/admin/productions/:production_id/lines/:id', params, options),
    method: 'patch',
  }),
}
